export const uploadTrackTaskIsActive = (
    task: UploadTrackTask | null,
): boolean => {
    if (task === null) {
        return false;
    }

    if (task.done || task.canceled || task.paused) {
        return false;
    }

    return true;
};
